import { render, staticRenderFns } from "./WordcloudResult.vue?vue&type=template&id=a81fd72a&"
import script from "./WordcloudResult.vue?vue&type=script&lang=ts&"
export * from "./WordcloudResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports